import { useNavigate } from 'react-router-dom';

export default function HeroSection() {
  const navigate = useNavigate();

  const handleRequest = () => {
    navigate('/contact');
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://storage.readdy-site.link/project_files/9f7657ab-f569-48d2-8f92-40b7994f5bf4/99c91ac6-21b7-4496-ab10-d31a88caaa50_compressed_ChatGPT-Image-Jul-16-2026-01_12_02-PM.webp"
          alt="MCT Residential Services - Caregiver and young person in a warm, welcoming home"
          title="MCT Residential Services - Youth Group Home"
          className="w-full h-full object-cover object-top scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/65 via-foreground-950/40 to-foreground-950/60"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 pt-28 pb-20">
        <div className="max-w-3xl">
          <div className="animate-hero-entrance">
            <h1 className="heading-font text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-[1.08] mb-5 tracking-tight">
              Every Young Person Deserves a Turning Point.
            </h1>
          </div>
          <div className="animate-hero-fade-in" style={{ animationDelay: '0.2s' }}>
            <p className="text-white/80 text-base md:text-lg lg:text-xl leading-relaxed mb-8 max-w-2xl font-light">
              Trauma-informed residential care that prepares young people for lifelong success&mdash;not just their next placement.
            </p>
          </div>

          <div className="flex flex-wrap gap-x-8 gap-y-2.5 mb-10 animate-hero-fade-in" style={{ animationDelay: '0.4s' }}>
            {[
              'Immediate Availability',
              'Youth Ages 12&#8211;18',
              '24-Hour Response',
              'Relationship-Based Care',
            ].map((item) => (
              <div key={item} className="flex items-center gap-2 text-white/75 text-sm font-medium label-font">
                <span className="w-5 h-5 flex items-center justify-center text-accent-400 flex-shrink-0">
                  <i className="ri-check-line text-sm"></i>
                </span>
                {item}
              </div>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row gap-4 animate-hero-fade-in" style={{ animationDelay: '0.6s' }}>
            <button
              onClick={handleRequest}
              className="inline-flex items-center justify-center gap-2 bg-white text-foreground-900 px-8 py-4 rounded-full text-base font-semibold label-font hover:bg-white/90 transition-all duration-300 cursor-pointer whitespace-nowrap group shadow-lg shadow-foreground-950/20"
            >
              Request Placement
              <span className="w-5 h-5 flex items-center justify-center group-hover:translate-x-1 transition-transform">
                <i className="ri-arrow-right-line"></i>
              </span>
            </button>
            <a
              href="#approach"
              className="inline-flex items-center justify-center gap-2 border border-white/30 text-white px-8 py-4 rounded-full text-base font-medium label-font hover:bg-white/10 hover:border-white/50 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Learn About Our Approach
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-down-line"></i>
              </span>
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <span className="w-8 h-8 flex items-center justify-center text-white/50">
          <i className="ri-arrow-down-line text-xl"></i>
        </span>
      </div>
    </section>
  );
}